// @flow
export { default } from './RegisterForm';



// WEBPACK FOOTER //
// ./src/components/register/RegisterForm/index.js